var App = App || {};

App.HomepageBanner = (function ($) {
    "use strict";

    function init() {
        var $homepageBanner = $(".widget.widget-homepage-banner");

        if ($homepageBanner.hasClass("has-video")) {
            let videoElem = $homepageBanner.find("video")[0];
            calculateDynamicHeights();

            var resizeTimer;

            $(window).on("resize", function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(calculateDynamicHeights, 100);
            });

            if (window.matchMedia) {
                var mql = window.matchMedia("(orientation: portrait)");

                mql.addEventListener("change", function () {
                    setTimeout(calculateDynamicHeights, 200);
                });
            }

            $(window).on("orientationchange", function () {
                setTimeout(calculateDynamicHeights, 200);
            });

            if($homepageBanner.hasClass("has-video-file")){
                let playButton = $homepageBanner.find(".btn-play-toggle")[0];

                playButton.addEventListener("click", handlePlayButton);
                playVideo(playButton);
            }

            if($homepageBanner.hasClass("has-video-embed")){
                const player = new Vimeo.Player($homepageBanner.find("iframe")[0]);
                let thumbnail = $homepageBanner.find(".homepage-video__thumbnail");
                let playButton = $homepageBanner.find(".btn-play-toggle")[0];
                var isVimeoPlaying = false;

                player.ready().then(function () {
                    isVimeoPlaying = true;
                    playVimeo(player, playButton, isVimeoPlaying);
                });

                playButton.addEventListener("click", function () {
                    isVimeoPlaying = !isVimeoPlaying;
                    playVimeo(player, playButton, isVimeoPlaying);
                });
            }

            function toggleButton(playButton, playing) {
                if (playing) {
                    playButton.querySelector(".fa-play").classList.add("d-none");
                    playButton.querySelector(".fa-pause").classList.remove("d-none");
                    playButton.setAttribute("aria-label", "Pause Video");
                } else {
                    playButton.querySelector(".fa-play").classList.remove("d-none");
                    playButton.querySelector(".fa-pause").classList.add("d-none");
                    playButton.setAttribute("aria-label", "Play Video");
                }
            }

            function playVimeo(player, playButton, play = true) {
                if (play) {
                    try {
                        player.play().catch(error => {
                            console.error('Error playing video:', error);
                        });
                        toggleButton(playButton, true);
                    } catch (err) {
                        toggleButton(playButton, false);
                    }
                } else {
                    try {
                        player.pause().catch(error => {
                            console.error('Error pausing video:', error);
                        });
                        toggleButton(playButton, false);
                    } catch (err) {
                        toggleButton(playButton, true);
                    }
                }
            }

            async function playVideo(playButton) {
                try {
                    await videoElem.play();
                    toggleButton(playButton, true);
                } catch (err) {
                    toggleButton(playButton, false);
                }
            }

            function handlePlayButton(e) {
                const playButton = e.currentTarget;
                if (videoElem.paused) {
                    playVideo(playButton);
                } else {
                    videoElem.pause();
                    toggleButton(playButton, false);
                }
            }
        }
    }

    function calculateDynamicHeights() {
        var $header = $("header");
        var $alerts = $("#Alerts");

        if ($header.length) {
            var headerHeight = $header.outerHeight();

            document.documentElement.style.setProperty("--header-height", headerHeight + "px");
        }

        if ($alerts.length) {
            var alertsHeight = $alerts.outerHeight();

            document.documentElement.style.setProperty("--alerts-height", alertsHeight + "px");
        } else {
            document.documentElement.style.setProperty("--alerts-height", "0px");
        }
    }

    return {
        init: init,
        updateHeights: calculateDynamicHeights
    };
})(jQuery);

$(function () {
    App.HomepageBanner.init();
});